/**
 * 不同题型的字段
 */

// 全部都有的字段
const basicFields = [
  'id',
  'title',
  'titleAlias',
  'type',
  'images',
  'text',
  'textPrefix',
  'jumpTargetId',
  'delay',
  'guideText',
  'guideVideo',
  'guideAudio',
  'forceGuideVideo',
  'forceGuideAudio',
  'auditText',
  'keyin_ids',
  'ondutyCheck',
  'throughRecordKeyQuestion',
  'allow_screen_capture',
  'allow_media_download',
]
// 多次重用组合
const reusing = [
  'referIds',
  'needEvidence',
  'localFile',
  'clarity',
  'minDuration',
  'evidenceQuality',
  'evidenceType',
  'imageRecognitionType',
  'takePhotoAuxiliaryLine',
  'allowReusePhoto',
  'allowCrossSubjectRecord',
  'reportedTablesAssociationStepId'
]

const hasEvidenceFields = [
  'takePhotoScene', // 2022-07-13 新增拍照场景（陈列分组拍摄），是 forcePanorama 字段的替代
]

export default {
  info: [
    ...basicFields,
    ...reusing,
    ...hasEvidenceFields,
    'dataLabel',
    'intelligentCall',
  ].sort(),
  text: [
    ...basicFields,
    ...reusing,
    ...hasEvidenceFields,
    'inputType',
    'inputMin',
    'inputMax',
    'dataLabel',
    'intelligentCall',
  ].sort(),
  multitext: [
    ...basicFields,
    'referIds',
    'options',
    'intelligentCall',
  ].sort(),
  multiselect: [
    ...basicFields,
    ...reusing,
    ...hasEvidenceFields,
    'options',
  ].sort(),
  imageMultiselect: [
    ...basicFields,
    ...reusing,
    ...hasEvidenceFields,
    'options',
  ].sort(),
  select: [
    ...basicFields,
    ...hasEvidenceFields,
    'clarity',
    'minDuration',
    'evidenceQuality',
    'evidenceType',
    'allowReusePhoto',
    'allowCrossSubjectRecord',
    'imageRecognitionType',
    'options',
    'dataLabel',
    'reportedTablesAssociationStepId'
  ].sort(),
}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/convert-fields/question-types.js